import React from "react";

export function getPasswordLabel(pickupType: string): React.ReactNode {
  return pickupType === "passphrase" ? (
    "Passphrase"
  ) : pickupType === "license" ? (
    <>
      <span>Driver's License Number</span>
      <span className="relative ml-2 inline-block text-xs text-slate-500 cursor-help group">
        ?
        <span className="pointer-events-none absolute bottom-full left-1/2 z-10 hidden w-64 -translate-x-1/2 rounded bg-slate-900 px-2 py-1 text-[10px] leading-tight text-white shadow-lg group-hover:block">
          Driver&#39;s license number will not be stored; only a hash will be saved. It will be used to pick children up.
        </span>
      </span>
    </>
  ) : (
    "Passphrase"
  );
}
